import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-tab-carousel]',
  carouselLatestPosts: '[data-latest-posts]',
};

class BlogPost extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(max-width:1023px)');

      // Init the carousel on load.
      this.initCarousels();

      // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
      // If not, it will get destroyed.
      this.registerEventListeners();
    });
  }

  initCarousels() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
    }

    if (this.breakpoint.matches) {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 15,
        watchOverflow: true,
      });
    } else {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 24,
        watchOverflow: true,
      });
    }

    if (this.breakpoint.matches) {
      this.carousel = new Swiper(selectors.carouselLatestPosts, {
        modules: [Scrollbar],
        freeMode: true,
        slidesPerView: 1.2,
        spaceBetween: 15,
        watchOverflow: true,
        scrollbar: {
          el: '.slider-scrollbar',
          draggable: true,
          hide: false,
          snapOnRelease: false,
          dragSize: 100,
        },
        breakpoints: {
          640: {
            slidesPerView: 2.2,
          },
          1024: {
            slidesPerView: 3.2,
          },
        },
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('blog-post', BlogPost);
